<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="processExceptions">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editPage.open(0)"> 新建 </el-button>
        <el-button :loading="exportLoading" type="primary" @click="exportExcel()">
          导出
        </el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="单号">
            <el-input v-model.trim="filter.billNo" clearable/>
          </vm-search>
          <vm-search label="出厂编号">
            <el-input v-model.trim="filter.factoryNo" clearable/>
          </vm-search>
          <vm-search label="创建人">
            <el-input v-model.trim="filter.creatorName" clearable/>
          </vm-search>
          <vm-search label="创建时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.beginCreateTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 165px"
                  placeholder="选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endCreateTime"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 165px"
                  placeholder="选择结束时间"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column type="expand" width="60">
        <template slot-scope="scope">
          <el-table :data="scope.row.processExceptionMaterialVOS">
            <el-table-column prop="materialNo" label="物料编号" align="center"/>
            <el-table-column prop="materialName" label="物料描述" align="center"/>
            <el-table-column prop="badNum" label="不良数量" align="center"/>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="billNo" label="单号" align="center" width="160">
        <template slot-scope="scope">
          <span style="color:#2d8cf0;cursor: pointer" @click="gotoPreview(scope.row)">{{scope.row.billNo}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="factoryNo" label="出厂编号" align="center"/>
      <el-table-column prop="customerName" label="客户名称" align="center"/>
      <el-table-column prop="createTime" label="创建时间" align="center" width="160"/>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">待提交</span>
          <span v-else-if="scope.row.status === 5">已退回</span>
          <span v-else-if="scope.row.status === 10">已提交</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button type="primary" :disabled="scope.row.status === 10" @click="$refs.editPage.open(scope.row.pkid)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <process-exception-edit ref="editPage" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable";
  import VmSearch from "@/components/VmSearch";
  import ProcessExceptionEdit from "./ProcessExceptionsEdit";
  export default {
    name:"ProcessExceptionsList",
    components:{ VmTable, VmSearch,ProcessExceptionEdit},
    data() {
      return {
        exportLoading:false,
        filter:{
          billNo:"" ,
          creatorName:"" ,
          factoryNo:"" ,
          beginCreateTime:"" ,
          endCreateTime:"" ,
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods:{
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      gotoPreview(row) {
        this.$router.push({
          path:"/ProcessExceptionsPreview",
          query:{
            billType:24,
            billId: row.pkid,
          },
        });
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "processExceptions/exportProcessException", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };

</script>

<style>

</style>